<template>
  <div class="flex-row mt-5 animated fadeIn">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col sm="9" md="9" lg="5" xl="5">
          <b-card-group>
            <b-card no-body class="p-3">
              <b-card-body>
                <div class="text-center">
                  <!-- <img src="static/img/sgce-logo2.jpg" class="rounded" alt="SGCE" > -->
                  <h3>SFC</h3>
                  <h4>Sistema de Finalização</h4>
                  <h4>para Credenciados</h4>
                  <br>
                </div>
                <h3 class="text-muted">Atualizar Senha</h3>
                <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                <b-form>
                  <b-form-group>
                    <label>Usuário</label>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        :value="$store.getters.usuario.nome"
                        type="text"
                        :disabled="true"
                        autocomplete="username"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group>
                    <label>Senha Atual</label>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        placeholder="Digite a senha atual"
                        v-model="senhaAtual"
                        @input="$v.senhaAtual.$touch()"
                        :state="$v.senhaAtual.$error ? false : null"
                        autocomplete="current-password"
                      ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback>Uma senha é obrigatória</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group>
                    <label>Senha Nova</label>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        placeholder="Digite a nova senha"
                        v-model="senhaNova"
                        @input="$v.senhaNova.$touch()"
                        :state="$v.senhaNova.$error ? false : null"
                        autocomplete="new-password"
                      ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback>Uma senha é obrigatória. Mínimo de 8 caracteres</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group>
                    <label>Confirmação da Senha Nova</label>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        placeholder="Redigite a nova senha"
                        v-model="confirmacaoSenhaNova"
                        @input="$v.confirmacaoSenhaNova.$touch()"
                        :state="$v.confirmacaoSenhaNova.$error ? false : null"
                        autocomplete="new-password"
                      ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback>Erro na confirmação da nova senha</b-form-invalid-feedback>
                  </b-form-group>
                </b-form>
                <b-row>
                  <b-col cols="12">
                    <b-button
                      variant="primary"
                      :disabled="$v.$invalid"
                      @click.stop="salvarSenhaUsuario()"
                    >Salvar</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import UsuariosServicos from "./UsuariosServicos";

export default {
  name: "AtualizarSenha",
  data() {
    return {
      erros: [],
      senhaAtual: "",
      senhaNova: "",
      confirmacaoSenhaNova: ""
    };
  },
  methods: {
    salvarSenhaUsuario() {
      this.$store.dispatch("addRequest");
      UsuariosServicos.trocarSenhaUsuario(
        this.$store.getters.usuario.usuarioId,
        { senhaAtual: this.senhaAtual, senhaNova: this.senhaNova }
      ).then(response => {
        if (response) {
          if (response.success) {
            this.$toast.success(
              "Registro atualizado com sucesso!",
              "OK",
              this.$toastConfig.success
            );
            this.$store.dispatch("logout");
          } else {
            this.erros = response.errors;
          }
        }
        this.$store.dispatch("removeRequest");
      });
    }
  },

  validations: {
    senhaAtual: {
      required
    },
    senhaNova: {
      required,
      minLength: minLength(8)
    },
    confirmacaoSenhaNova: {
      sameAs: sameAs("senhaNova")
    }
  }
};
</script>
